import { ExternalLink } from 'lucide-react';
import { THERME_DIRECTIONS, THERME_MAP_IMAGE, THERME_MAP_URL } from './therme-groundbreaking-content';

function DirectionsList({ className = '' }) {
  return (
    <div className={`space-y-8 ${className}`.trim()}>
      {THERME_DIRECTIONS.map((item) => (
        <div key={item.title} className="flex gap-4 md:gap-5 items-start">
          <img
            src={item.icon}
            alt=""
            width={item.iconWidth}
            height={item.iconHeight}
            className="shrink-0 object-contain"
            style={{ width: item.iconWidth, height: item.iconHeight }}
          />
          <div>
            <h3 className="font-medium text-base md:text-lg leading-snug">{item.title}</h3>
            {item.paragraphs.map((text) => (
              <p key={text} className="mt-2 text-sm md:text-[15px] leading-relaxed text-[var(--text-secondary)]">
                {text}
              </p>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export function ThermeGettingThereClassic() {
  return (
    <section id="getting-there" className="py-12 md:py-16 border-t border-[var(--border-default)]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="text-overline mb-4">Find us</div>
        <h2 className="font-heading text-2xl md:text-3xl tracking-tight font-medium leading-tight mb-8">
          Getting to IMBA Theatre
        </h2>

        <div className="border border-[var(--border-default)] bg-[var(--bg-surface)]">
          <div className="p-6 md:p-8 border-l-[3px] border-[var(--primary)] bg-[#f3ede2] text-[var(--text-primary)]">
            <DirectionsList className="[&_p]:text-[#2c3447]" />
          </div>

          <a
            href={THERME_MAP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block group"
            aria-label="Open IMBA Theatre in Google Maps"
          >
            <img
              src={THERME_MAP_IMAGE}
              alt="Map showing walking and shuttle paths to IMBA Theatre"
              className="w-full h-auto block"
            />
            <div className="flex items-center justify-center gap-2 py-4 text-sm font-medium text-[var(--primary)] group-hover:underline">
              Open in Google Maps
              <ExternalLink size={14} aria-hidden />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}

export function ThermeGettingTherePremium() {
  return (
    <section id="getting-there" className="border-t border-white/10 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <div className="therme-gold-line mb-5" aria-hidden />
        <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-[var(--therme-gold)]">Find us</p>
        <h2 className="therme-display mt-3 text-2xl font-semibold tracking-tight md:text-3xl">
          Getting to IMBA Theatre
        </h2>

        <div className="therme-glass-card mt-8 overflow-hidden">
          <div className="border-l-[3px] border-[var(--therme-gold)] bg-[#f3ede2]/95 p-6 md:p-8 text-[#1a2235]">
            <DirectionsList className="[&_h3]:text-[#1a2235] [&_p]:text-[#2c3447]" />
          </div>

          <a
            href={THERME_MAP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block group"
            aria-label="Open IMBA Theatre in Google Maps"
          >
            <img
              src={THERME_MAP_IMAGE}
              alt="Map showing walking and shuttle paths to IMBA Theatre"
              className="w-full h-auto block"
            />
            <div className="flex items-center justify-center gap-2 py-4 text-sm font-medium text-[var(--therme-gold)] group-hover:underline">
              Open in Google Maps
              <ExternalLink size={14} aria-hidden />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
